import { render, staticRenderFns } from "./ProductInfoVideoTemplate.vue?vue&type=template&id=73291f1e&"
import script from "./ProductInfoVideoTemplate.vue?vue&type=script&lang=js&"
export * from "./ProductInfoVideoTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports